import {FC} from 'react';
import {termsOfUseSx} from './Terms.sx';
import {Box, Typography} from '@mui/material';

export const Terms: FC = () => {
    return (
        <Box sx={termsOfUseSx.root}>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT SA
            </Typography>
            <Typography variant="h2">Terms of Service</Typography>

            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                <em>September 2026</em>
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                1 – PURPOSE
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                These Terms of Service ("Terms of Service") of AMP IT SA and/or its subsidiaries, holding company or
                sister company ("AMP IT") govern the use of the website amp-it.com (the "Website") as well as the use of
                all applications (SaaS) and software offered by AMP IT (the "Applications") (the Website and the
                Applications, together the "Services"). For drafting purposes, use of the singular includes the plural
                and vice versa, and use of the masculine includes the feminine and vice versa. By using the Website and
                the Applications, each user declares that they have read these Terms of Service and accept their content
                without reservation. Each user is also informed of AMP IT's privacy policy. No general terms and
                conditions that conflict with or derogate from these Terms of Service or from AMP IT's specific general
                terms and conditions shall apply to the relationship between AMP IT and the user.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                2 – AMP IT'S SPECIFIC TERMS AND CONDITIONS
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT reserves the right to submit a user to any specific general terms and conditions that are
                separate from, cumulative with and/or that derogate from these Terms of Service in connection with its
                Services. Such specific terms and conditions shall apply without reservation to the contractual
                relationship between AMP IT and the user.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                3 – USE OF THE SERVICES
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Any user may browse the public part of the Website without being required to register. Registration is
                nevertheless mandatory to use the Applications and to make use of AMP IT's Services. AMP IT reserves the
                right to close any public browsing and to require users to register at any time in order to access its
                Services.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                The Services offered by AMP IT are open only to persons of legal age with capacity to exercise
                judgement, as well as to legal entities registered in a commercial register or whose existence can be
                evidenced by documents.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                If the user is a legal entity, AMP IT may validly communicate with each person registered in the
                commercial register individually (including where that person has joint signing authority or no signing
                authority at all) or with any person involved in handling the matter on behalf of the legal entity
                (including where that person is not listed in the commercial register); to the extent necessary, the
                contractual documentation with AMP IT (including these Terms of Service) shall be deemed to constitute a
                power of attorney granted by the legal entity in favor of such persons.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                4 – INSTRUCTIONS
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT does not accept instructions from users. Should a user give any instruction to AMP IT, such
                instruction shall only be validly given if AMP IT accepts it. In the absence of such acceptance, AMP IT
                assumes no obligation whatsoever – including in case of emergency – towards the user.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                5 – ACCURACY OF INFORMATION AND SUBSEQUENT CHANGES
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Any user who uses the Applications to benefit from AMP IT's Services and/or who wishes to benefit from
                AMP IT's Services undertakes to provide, when creating a user account, truthful information and, upon
                AMP IT's request, any supporting documents.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Each user is responsible for the information provided upon registration and recorded in their user
                account and bears sole responsibility for its use. In order to benefit from AMP IT's Services, each user
                undertakes to keep the information in their account up to date. If AMP IT uses third-party services to
                verify a user's information, the data collected by such third party following verification shall be used
                by AMP IT and shall replace the data recorded by the user (for example in the event of errors identified
                following a verification of data relating to billing or otherwise).
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT assumes that the information and documents provided by each user are complete and accurate; AMP
                IT therefore has no obligation to carry out any further verification and may rely on the information and
                documents provided by the user. If information or documents provided by the user need to be updated,
                each user undertakes to immediately update their information. Each user must ensure that AMP IT
                receives, in a timely manner, all information necessary for the performance of its Services.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT may at any time verify the information recorded by a user and request supporting documents. In
                the event of failure to comply with this duty to inform, AMP IT may, at any time, close a user's account
                and/or decline to provide services to them – at the user's expense – without any liability whatsoever.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT may under no circumstances be held liable to a user or a third party for any damage, including
                indirect or consequential damage, in particular including loss of profit, savings, production, contracts
                or business opportunities, arising in connection with incomplete or incorrect information.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                6 – COOPERATION WITH AMP IT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Each user undertakes to perform, upon AMP IT's first request, any act and to sign any documents that may
                be necessary to carry out and/or perform AMP IT's obligations.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                7 – COMMUNICATION
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                The user agrees that any correspondence may be transmitted electronically and/or made available in the
                relevant Application, including in unencrypted form. AMP IT assumes that communications sent to each
                user and/or to any person involved in handling the matter have reached them. AMP IT is therefore not
                required to ensure proper receipt of each communication by other means.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Each user is informed of and consents to any communication with AMP IT being used and/or disclosed by
                AMP IT in the performance of its obligations. In this context, AMP IT is authorized – without any
                limitation – to disclose information communicated by a user to a third party, to the extent necessary.
                AMP IT is released from any duty of confidentiality or duty of care in connection with its
                communications with users and third parties.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                In order to allow each user to access their documentation themselves, AMP IT may use certain tools
                directly accessible to the user. AMP IT uses its best efforts to ensure, at all times, access to each
                user's account and/or the availability of its applications/services, but cannot guarantee it.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT may under no circumstances be held liable to a user or a third party for any damage, including
                indirect or consequential damage, in particular including loss of profit, savings, production, contracts
                or business opportunities, in particular in the event of disclosure of information, issues accessing the
                documentation and/or accessibility of AMP IT's tools, applications and/or services by the user.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                8 – DATA STORAGE AND PAPERLESS OPERATION
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT digitizes its services and document management as much as possible. As a rule, all paper
                documents are scanned and then destroyed. Each user is made aware that no paper files are kept by AMP
                IT. If a user submits documents to AMP IT without AMP IT having requested them, the user runs the risk
                that such documents will be destroyed. In all cases, AMP IT is free to destroy any documents and/or data
                relating to a user upon expiry of a ten-year period.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT may under no circumstances be held liable to a user or a third party for any damage, including
                indirect or consequential damage, in particular including loss of profit, savings, production, contracts
                or business opportunities, in connection with the destruction of data and/or documents.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                9 – NON-TRANSFERABILITY OF THE USER ACCOUNT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Each user account is personal and may under no circumstances be transferred to a third party without AMP
                IT's prior written authorization. A legal entity may hold several named accounts (in the names of
                different users). Each user undertakes to take all measures to keep their account secret and to preserve
                its confidentiality. The confidentiality of an account is the sole responsibility of the user, who
                releases AMP IT from any liability in this respect.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Each user is responsible for the use of their account and bears the consequences of any transactions
                arising from such use (including in the event of unauthorized use). Each user must immediately inform
                AMP IT in the event of loss of access to, or fraudulent use of, their account.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT may under no circumstances be held liable to a user or a third party for any damage, including
                indirect or consequential damage, in particular including loss of profit, savings, production, contracts
                or business opportunities, in connection with the improper use of a user account.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                10 – AVAILABILITY OF THE SERVICES
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT uses its best efforts to ensure access to its Services at all times but cannot guarantee it. AMP
                IT may under no circumstances be held liable to a user or a third party for any damage, including
                indirect or consequential damage, in particular including loss of profit, savings, production, contracts
                or business opportunities, in connection with the unavailability of its Services.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                11 – SUPPORT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                All logistical support from AMP IT is provided through its Applications. The user is not entitled to
                request telephone support or on-site support. Specific fees may be charged to a user.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                12 – REGULATORY FRAMEWORK
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Each user is aware that the Swiss regulatory framework must be complied with at all times. Each user is
                responsible for ensuring the legality of their own acts in connection with their use of the Services.
                AMP IT may under no circumstances be held liable to a user or a third party for any damage, including
                indirect or consequential damage, in particular including loss of profit, savings, production, contracts
                or business opportunities, in connection with a breach of the regulatory framework by the user.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                13 – NO ADVICE OR RECOMMENDATIONS AND VIRTUAL ASSISTANT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Each user acknowledges and understands that AMP IT does not provide any advice or make any
                recommendations. Each user is therefore solely responsible for the choices they make when using AMP IT's
                Services.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                No information and/or document provided on the Website and/or the Applications shall be regarded as a
                recommendation, advice, solicitation or inducement to carry out one act rather than another.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT provides users with a virtual assistant based on artificial intelligence, intended to facilitate
                support and answer routine requests relating to the Services. The user is informed, at the beginning of
                each conversation, that they are interacting with an automated system and not a person. The user may
                request to be directed to a member of staff. Any responses provided by the virtual assistant are
                generated automatically and may contain inaccuracies. Such responses therefore do not constitute advice
                or a recommendation, and the user remains solely responsible for the use they make of them. Use of the
                virtual assistant is not mandatory in order to access AMP IT's Services.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                14 – GENERAL EXCLUSION OF LIABILITY
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT may under no circumstances be held liable to a user or a third party for any damage, including
                indirect or consequential damage, in particular including loss of profit, savings, production, contracts
                or business opportunities, in connection with the use of the Applications and in the context of its
                Services, except in the case of gross negligence or wilful misconduct towards a user.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                As part of its services, AMP IT provides its clients with communication, chat, automated support and
                artificial intelligence (AI) tools, in particular in order to facilitate the use of its Services,
                respond to users' requests, provide support or improve its services. The responses or information
                generated by means of such tools may be produced automatically and do not necessarily constitute advice
                or recommendations from AMP IT. The user acknowledges that results generated by AI tools may contain
                errors or inaccuracies and should not be used without verification where an important decision or action
                depends on them. The user releases AMP IT from any liability in connection with the use of automated
                support or artificial intelligence, except in the case of gross negligence or wilful misconduct towards
                a user.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                15 – DATA PROTECTION
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Data may be collected when using the Website, the Applications, and during contact with AMP IT.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT undertakes to process its users' data in accordance with applicable legislation. Each user is
                nevertheless informed that certain data collected by AMP IT (i) is used to administer their personal
                account, (ii) may be transferred to third parties to the extent necessary for the performance of the
                Services and the use of the Applications, (iii) is used to send advertising and targeted offers, or (iv)
                is used for debt-collection purposes.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                In connection with these Services, AMP IT may use communication, chat, automated support and artificial
                intelligence (AI) tools, in particular in order to facilitate the use of its Services, respond to users'
                requests, provide support or improve its services. AMP IT may process information communicated by the
                user to the extent necessary for the provision and improvement of its services. AMP IT may process
                personal data.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                The user undertakes to communicate, via the chat or any AI tool made available by AMP IT, only the data
                necessary for the use of the Service and for their needs. The user undertakes not to enter sensitive
                personal data, confidential data or information whose communication to such a tool would be prohibited
                or would require special measures, unless expressly indicated otherwise by AMP IT.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                To the extent that AI tools or third-party providers are used to provide the Services, certain data may
                be processed by such providers, including, where applicable, abroad. AMP IT ensures that any processing
                of personal data is carried out in accordance with applicable legal requirements. The user may, at any
                time, consult AMP IT's privacy policy.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                16 – AMENDMENT OF THE TERMS OF SERVICE
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT reserves the right to amend these Terms of Service at any time. AMP IT shall inform users thereof
                by e-mail or by notification. In the absence of any objection by the user within ten (10) days of such
                notice, the amended Terms of Service shall be deemed accepted. Each user is required to keep informed of
                the applicable Terms of Service. In the event of a dispute, the Terms of Service in force at the
                relevant time shall apply. If a contractual relationship was entered into with a user on a given date,
                that relationship shall be governed by the Terms of Service in force at the time it was entered into,
                subject to the application of specific or subsequent general terms and conditions.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                17 – INTELLECTUAL PROPERTY
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                All intellectual property rights relating to the Services as well as to the documentation relating to
                the services provided remain the exclusive property of AMP IT. Any reproduction is prohibited and may
                give rise to legal proceedings.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                18 – APPLICABLE LAW
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Any contract entered into and any relationship with AMP IT, as well as these Terms of Service, shall be
                governed solely by substantive Swiss law.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Subject to any mandatory place of jurisdiction, any dispute, disagreement or claim arising out of or in
                connection with a contract, a relationship with AMP IT, or these Terms of Service, shall be settled by
                the courts having jurisdiction at AMP IT's registered office.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT SA
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Address: 1-3 Rue des Sablières, 1242 Satigny, Switzerland
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Telephone: +41 22 525 77 22
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                E-mail: <a href="mailto:info@amp-it.ch">info@amp-it.ch</a>
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Company registration No.: CHE-398.067.199
            </Typography>
        </Box>
    );
};